/**
 * Dependencies.
 */
import CommentTypeModel from '@/api/delivery-survey-comment/comment-type.model';
import applicationConstant from '@/modules/main/constants/application.constant';
import { BaseService } from '@/modules/main/services/base.service';

/**
 * Service.
 */
class CommentTypeService extends BaseService<CommentTypeModel> {
  /**
   * Constructor.
   */
  constructor() {
    super(
      CommentTypeModel,
      CommentTypeModel.name,
      applicationConstant.apiCustomerPublicUrl
    );
  }
}

/**
 * Export `commentTypeService`.
 */
export const commentTypeService = new CommentTypeService();
